import axios from 'axios'
export const API_URL = 'https://backend.nft-store.marketmaking.pro'

export const instance = axios.create({
  baseURL: 'https://backend.nft-store.marketmaking.pro/api',
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  }
});